import React from "react";
import type { Placement as PopperPlacementType } from "popper.js"
import { isAF } from "../../lib/instanceSettings";
import LWTooltip from "./LWTooltip";

const KarmaDisplay = ({document, placement="left", linkItem}: {
  document: VoteableType,
  placement?: PopperPlacementType,
  linkItem?: React.ReactNode,
}) => {
  const baseScore = isAF()
    ? document.afBaseScore
    : document.baseScore;
  const afBaseScore = !isAF() && document.af
    ? document.afBaseScore
    : null;
  return (
    <LWTooltip
      placement={placement}
      clickable={!!linkItem}
      title={
        <div>
          <div>{baseScore ?? 0} karma</div>
          <div>({document.voteCount} votes)</div>
          {linkItem}
          {afBaseScore &&
            <div><em>({afBaseScore} karma on AlignmentForum.org)</em></div>
          }
        </div>
      }
    >
      {baseScore ?? 0}
    </LWTooltip>
  );
};

export default KarmaDisplay;


